import React from 'react';
import { Spacing, Text } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import PaymentImage from '../../../ui/atoms/PaymentImage';

const PixForm = () => {
  const { t } = useTranslation('payment');

  return (
    <div className="checkout-section">
      <Spacing vertical>
        <PaymentImage type="pix-logo" />

        <Text size="M" weight="bold">
          {t('pix_instructions.first')}
        </Text>

        <Text size="S">{t('pix_instructions.second')}</Text>

        <Text size="S" italic>
          {t('pix_instructions.third')}
        </Text>
      </Spacing>
    </div>
  );
};

export default PixForm;
